import { j as o } from "../../../jsx-runtime-BwWtxLpl.js";
import { useContext as F, useState as a, useEffect as y } from "react";
import { FileUploaderProvider as P } from "./file-uploader.context.js";
import { useDropzone as z } from "react-dropzone";
import D from "classnames";
import "../form-field/form-field.js";
import { FormFieldContext as L } from "../form-field/form-field.context.js";
import { IconoirCloudUpload as q, IconoirWarningCircle as w } from "@ey-xd/motif-icon";
import { MotifIcon as A } from "../../icon/icon.js";
import { IconContext as S } from "../../icon/icon.context.js";
let I;
I = 0;
const W = {
  upload: q,
  uploadError: w
}, _ = ({
  children: C,
  className: N,
  disabled: n,
  label: d,
  labelDescription: p,
  icons: c,
  id: f,
  onDrop: m,
  ...i
}) => {
  const e = F(L), { fileUploader: u } = F(S), [h, x] = a(d), [$, j] = a(p), U = {
    "too-many-files": `Attach up to ${i.maxFiles} file${i.maxFiles > 1 ? "s" : ""}`
  };
  let t;
  u ? t = {
    ...u,
    ...c
  } : t = {
    ...W,
    ...c
  }, a(() => {
    f ? e.setId(f) : e.setId(`motif-file-uploader-${I++}`);
  });
  const E = D({
    "motif-file-uploader": !0,
    "motif-disabled": n,
    "motif-invalid": e.invalid,
    [`${N}`]: !0
  }), { getRootProps: M, getInputProps: R, acceptedFiles: b, fileRejections: g, open: T } = z({
    ...i,
    disabled: n
  });
  return y(() => {
    if (m) {
      const r = [...b, ...g].map((l) => {
        if ("errors" in l) {
          e.setInvalid(!0);
          const { file: s, errors: v } = l;
          return s.error = v[0].message, s.errorCode = v[0].code, s;
        }
        return e.setInvalid(!1), x(d), j(p), l;
      });
      if (r.length) {
        if (r[0].error) {
          x(r[0].error), j(
            U[r[0].errorCode] || r[0].error
          );
          return;
        }
        m(r);
      }
    }
  }, [b, g]), /* @__PURE__ */ o.jsx(P, { value: { onRetry: T }, children: /* @__PURE__ */ o.jsxs("div", { className: E, "data-motif-file-uploader": !0, "data-testid": "file-uploader-wrapper", children: [
    /* @__PURE__ */ o.jsxs("button", { className: "dropzone-container", ...M(), children: [
      /* @__PURE__ */ o.jsx("input", { id: e.id, ...R(), "aria-labelledby": `${e.id}-label` }),
      /* @__PURE__ */ o.jsxs("span", { className: "motif-file-uploader-label", id: `${e.id}-label`, children: [
        /* @__PURE__ */ o.jsx(
          A,
          {
            fill: "none",
            className: "motif-file-uploader-icon",
            iconFunction: e.invalid ? t.uploadError : t.upload
          }
        ),
        /* @__PURE__ */ o.jsx("span", { className: "motif-file-uploader-label-text", children: h }),
        /* @__PURE__ */ o.jsx("span", { className: "motif-file-uploader-label-description", children: $ })
      ] })
    ] }),
    C
  ] }) });
};
export {
  _ as MotifFileUploader
};
